import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import { Weather } from "@weather/domain/models/weather.model";
import type { WeatherRepository } from "@weather/domain/repositories/weather.repository";
import { weatherTypes } from "@weather/weather-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class WeatherGetAllUseCase {
    constructor(
        @inject(weatherTypes.repositories.WeatherRepository)
        private readonly weatherRepository: WeatherRepository,
    ) {}

    async execute(stationId: string): Promise<Nullable<Weather>> {
        const weatherResult = await this.weatherRepository.getAll(stationId);

        if (weatherResult.isErr()) {
            ToastManagerRepository.error(weatherResult.error.message);
        }

        return weatherResult.match(
            (weather) => weather,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
